import { render, staticRenderFns } from "./userAuditReport.vue?vue&type=template&id=48083e92&"
import script from "./userAuditReport.vue?vue&type=script&lang=js&"
export * from "./userAuditReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports